/* Malichus encyclopedia - the drawing on an invention card.
   Every card in "Milestones and inventions" carried a drawing chosen by topic
   rather than by subject, which produced three faults a reader can see:
   a generic placeholder drawing on cards that illustrate nothing in particular,
   the same drawing repeated across several cards of one brand, and a drawing
   whose subject is not what the card is about - the legibility lab appearing
   on "Breguet hands" and "Breguet numerals", neither of which is about
   legibility.
   The rule applied here: a drawing is shown only where it depicts the
   invention the card names. A card that loses its drawing shows its text and
   no button at all, which is honest; it never shows a placeholder.
   The brand story reads its chapters from window.MZ_BSP as each chapter file
   loads, so the data is corrected on the way in. */
(function(){
if(window.__mzifix)return;window.__mzifix=1;

/* Drawings that depict nothing in particular: a labelled "step" diagram and a
   generic timeline widget. They are removed wherever they appear. */
var GENERIC={concept:1,journey:1};

/* For a drawing used on more than one card of the same brand, the card that
   keeps it is the first whose title is actually about the drawing's subject.
   If no card in that brand is, none of them keeps it. A drawing with no entry
   here falls back to keeping the earliest card, which is normally the
   invention that introduced the feature. */
var OWNER={
 legibility:/وضوح|قراءة|رؤية|مضيء|مضيئ|إضاءة|برتقالي|لوم/,
 chrono:/كرونوغراف|كرونومات|كرونوماستر|سبيدتايمر|مؤقت|توقيت/,
 water:/ماء|غوص|غواص|أويستر|فاثوم|عمق|بحر|أكوا|دايفر|سيماستر|بروف|متر/,
 chrono2:/فلاي ?باك|العودة الفورية|منقسم|المنفصلة|المزدوج|زرين|الزر الثاني|سبليت/,
 thin:/رفيع|رقيق|رقة|أنحف|أرق|ألترا|نحيف|ملم/,
 repeater:/راصد|سونيري|رنين|جرس|تدق|تشايم|غونغ|التعقيد الكبير/,
 cal:/تقويم|كالندر|بربتشوال|بيربيتويل|كوانتييم/,
 case_shapes:/شكل|علبة|مربع|تانك|كراش|بالون|برميل|وسادة|مستطيل/,
 case_shape_gallery:/شكل|علبة|مربع|تانك|كراش|بالون|برميل|وسادة/,
 rotor:/ذاتية التعبئة|تعبئة ذاتية|أوتوماتيك|الدوار|الدوّار|ماتيك|بيلاتون|الرافعة السحرية|ربتشوال/,
 timing_test:/اختبار|مرصد|كرونومتر|شهادة|مسابقة|رقم قياسي/,
 evidence:/وثيق|سجل|أرشيف|دليل|براءة|أقدم/,
 case_materials:/فولاذ|ذهب|تيتانيوم|سيراميك|بلاتين|سبيكة|كربون|مادة/,
 material:/سيليكون|مغناطيس|سبيكة|سيراميك|مادة/,
 quartz:/كوارتز|بلورة/,
 smart:/ذكي|سمارت|شاشة|تطبيق/,
 tourbillon:/توربيون/,
 gmt:/جي إم تي|منطقت|توقيت ثان|24 ساعة|عالمي|مسافر/,
 solar:/شمس|ضوء|سولار|إيكو درايف/,
 shock:/صدم|بارشوت|إنكابلوك/,
 balance:/ميزان|توازن/,
 escapement:/مهرب|إفلات|منفلت/,
 spring:/نابض|زنبرك|برميل|احتياط/,
 atomic:/ذري|ذرة|سيزيوم|راديو/,
 dualsecond:/منقسم|مزدوج|رتراباند|سبليت|ثوان/,
 diver_bezel:/إطار|بيزل/,
 alarm:/منبه|كريكت/,
 led:/رقمي|إل إي دي|إلكتروني/,
 gps:/قمر|موقع|ملاحة/,
 anatomy:/تشريح|أجزاء|بنية/,
 space_test:/فضاء|ناسا|أبولو|قمر/,
 space_survival_test:/فضاء|ناسا|أبولو|قمر/,
 wristevo:/معصم|يد/,
 antimagnetic:/مغناطيس|ميلغاوس/,
 astro:/فلك|نجوم|سماء|كوكب|سماوي/,
 date:/تاريخ|ديت/,
 sliderule:/مسطرة|حاسبة|نافيتايمر/,
 distress_beacon:/استغاثة|طوارئ|إشارة/,
 tuningfork:/شوكة|رنانة|أكيوترون/,
 sdrive:/سبرينغ درايف/,
 beat_rate:/تردد|اهتزاز|هرتز/,
 swatch:/سواتش/,
 high_frequency_timing:/تردد|36000|عالي/,
 overcoil:/حلزون|طرفي|أوفركويل/,
 pressure_altimeter:/ارتفاع|ضغط/,
 cforce:/قوة ثابتة|ريمونتوار/
};

function clean(entry){
 if(!entry||typeof entry!=='object')return entry;
 var inv=entry.inv;
 if(!inv||!inv.length||entry.__ifx)return entry;
 var groups={},i,d,row;
 for(i=0;i<inv.length;i++){
  row=inv[i];if(!row)continue;
  d=row[4];if(!d)continue;
  if(d==='legibility'&&!/وضوح|قراءة|رؤية|مضيء|مضيئ|إضاءة|برتقالي|لوم|legibility|readab|lumin|visibility/i.test(String(row[1]||''))){row[4]='';continue}
  if(GENERIC[d]){row[4]='';continue}
  if(!groups[d])groups[d]=[];
  groups[d].push(i);
 }
 for(d in groups){
  if(!groups.hasOwnProperty(d))continue;
  var idx=groups[d];
  if(idx.length<2)continue;                    /* used once: left as it is */
  var re=OWNER[d],keep=idx[0];
  if(re){
   keep=-1;
   for(i=0;i<idx.length;i++){
    if(re.test(String(inv[idx[i]][1]||''))){keep=idx[i];break}
   }
  }
  for(i=0;i<idx.length;i++)if(idx[i]!==keep)inv[idx[i]][4]='';
 }
 try{Object.defineProperty(entry,'__ifx',{value:1,enumerable:false})}catch(e){entry.__ifx=1}
 return entry;
}

function sweep(){
 var s=window.MZ_BSP;if(!s)return;
 for(var k in s){if(s.hasOwnProperty(k))try{clean(s[k])}catch(e){}}
}

/* The chapter files assign into MZ_BSP as they load, so each one is corrected
   as it arrives, before the story is built from it. */
var store=window.MZ_BSP||{};
sweep();
try{
 window.MZ_BSP=new Proxy(store,{
  set:function(t,k,v){try{clean(v)}catch(e){}t[k]=v;return true}
 });
}catch(e){}
/* a browser without Proxy, or a chapter that arrived another way */
setTimeout(sweep,500);setTimeout(sweep,2000);
try{
 if(window.MutationObserver){
  var pend=0;
  new MutationObserver(function(){if(pend)return;pend=1;setTimeout(function(){pend=0;sweep()},60)})
   .observe(document.documentElement,{childList:true,subtree:true});
 }
}catch(e){}

})();
